function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#67BBB0",
  d: "M0,80C0,35.817,35.817,0,80,0s80,35.817,80,80s-35.817,80-80,80S0,124.183,0,80"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M107.966,42.25H52.035c-1.519,0-2.75,1.231-2.75,2.75v70c0,1.519,1.231,2.75,2.75,2.75h55.931 c1.518,0,2.75-1.231,2.75-2.75V45C110.716,43.481,109.483,42.25,107.966,42.25 M105.216,112.25H54.785v-64.5h50.431V112.25z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M64.012,67.578h9.989c0.967,0,1.75-0.783,1.75-1.75V55.84c0-0.967-0.783-1.75-1.75-1.75h-9.989 c-0.966,0-1.75,0.783-1.75,1.75v9.988C62.262,66.795,63.046,67.578,64.012,67.578 M65.762,57.59h6.488v6.487h-6.488V57.59z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M64.012,86.746h9.989c0.967,0,1.75-0.784,1.75-1.75v-9.99c0-0.967-0.783-1.75-1.75-1.75h-9.989 c-0.966,0-1.75,0.783-1.75,1.75v9.99C62.262,85.962,63.046,86.746,64.012,86.746 M65.762,76.756h6.488v6.488h-6.488V76.756z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M64.012,105.911h9.989c0.967,0,1.75-0.783,1.75-1.75v-9.988c0-0.968-0.783-1.75-1.75-1.75h-9.989 c-0.966,0-1.75,0.782-1.75,1.75v9.988C62.262,105.128,63.046,105.911,64.012,105.911 M65.762,95.923h6.488v6.487h-6.488V95.923z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M85.659,66.911c0.316,0.402,0.794,0.646,1.307,0.666c0.022,0.001,0.045,0.001,0.067,0.001 c0.487,0,0.954-0.203,1.286-0.563l8.932-9.676c0.655-0.71,0.61-1.817-0.1-2.473s-1.816-0.61-2.473,0.1l-7.541,8.168l-1.494-1.896 c-0.596-0.761-1.697-0.889-2.456-0.292c-0.759,0.599-0.89,1.697-0.292,2.458L85.659,66.911z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M85.659,85.921c0.316,0.402,0.794,0.646,1.307,0.666c0.022,0.001,0.045,0.001,0.067,0.001 c0.487,0,0.954-0.203,1.286-0.563l8.932-9.677c0.655-0.71,0.61-1.817-0.1-2.473s-1.816-0.61-2.473,0.1l-7.541,8.168l-1.494-1.896 c-0.596-0.759-1.697-0.888-2.456-0.292c-0.759,0.599-0.89,1.698-0.292,2.458L85.659,85.921z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M85.659,105.212c0.316,0.402,0.794,0.646,1.307,0.666c0.022,0.001,0.045,0.001,0.067,0.001 c0.487,0,0.954-0.203,1.286-0.563l8.932-9.677c0.655-0.71,0.61-1.817-0.1-2.473s-1.816-0.61-2.473,0.1l-7.541,8.168l-1.494-1.896 c-0.596-0.76-1.697-0.888-2.456-0.292c-0.759,0.599-0.89,1.698-0.292,2.458L85.659,105.212z"
});

var SvgAttivitaAccent = function SvgAttivitaAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.349 -0.524 161 161",
    enableBackground: "new -0.349 -0.524 161 161",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAttivitaAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attivita_accent.e5c51626.svg";
export { ForwardRef as ReactComponent };